<template>
  <div id="app" style="height: 100%!important;">
    <router-view  v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  created () {
    // font-size的初始化  rem的定义
    var htmlEl = document.getElementsByTagName('html')[0]
    var fitPage = function () {
      /* The calculate of with from zepto  */
      var w = htmlEl.getBoundingClientRect().width
      w = Math.round(w)
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      console.log("是否是手机："+flag)
      let lswidth = 1920;
      // let lswidth = 750;
      if(flag){
        w = w > 750 ? 750 : w
        lswidth = 750;
      }else{
        w = w > 1920 ? 1920 : w
      }
      var newW = w / lswidth * 100
      htmlEl.style.fontSize = newW + 'px'
    }
    fitPage()

    var t
    var func = function () {
      clearTimeout(t)
      t = setTimeout(fitPage, 25)
    }
    window.addEventListener('resize', func)
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue